export default __webpack_public_path__ + "static/media/apple_button_dark.204617be.png";